import { createWebHashHistory, createRouter } from "vue-router";

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: '',
            component: () => import('./components/signup/Signup.vue')
        },

        {path: "/:catchAll(.*)", redirect: '/'},
    ]
})

export default router
